<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="changePassForm">
      <div class="col-lg-12 col-md-12">
        <div class="card-body">
          <div class="bc d-flex align-items-center pl-3">
            <img alt="Logo" src="../../assets/img/password.gif" class="mh-40px pb-2">
            <div class="ml-2">
              <h3 class="main-content-label mb-1"><b>
                  Change Password
                </b></h3>
              <p class="text-muted card-sub-title mb-0">
                Change Password
              </p>
            </div>
          </div>
          <hr>
          <div class="row clearfix">
            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>
                    User Name
                  </mat-label>
                  <input readonly onkeydown="return (event.keyCode!=13);" class="color"
                    type="text" maxlength="100" placeholder="User Id" formControlName="LoginName" matInput>
                 
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>
                    Old Password
                  </mat-label>
                  <input required onkeydown="return (event.keyCode!=13);" class="color" [type]="showPassword ? 'text' : 'password'" maxlength="50"
                    placeholder="Old Password" formControlName="OldPswd" matInput>
                    <i alt="show" class="fa fa-eye-slash eye" (click)="showPassword = !showPassword" [class.hide]="showPassword"></i>
                    <i alt="hide" class="fa fa-eye eye" (click)="showPassword = !showPassword" [class.hide]="!showPassword"></i>
                
                  <mat-error class="margin_tp"
                    *ngIf="changePassForm.controls['OldPswd'].touched && changePassForm.controls['OldPswd'].errors?.pattern">
                   Invalid
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="changePassForm.controls['OldPswd'].touched && changePassForm.controls['OldPswd'].errors?.required">
                  Mandatory
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <mat-form-field appearance="outline" class="example-full-width">
                  <mat-label>
                    New Password
                  </mat-label>
                  <input [type]="showPassword2 ? 'text' : 'password'" required onkeydown="return (event.keyCode!=13);" class="color" maxlength="50"
                    placeholder="Password" formControlName="NewPswd" matInput>
                    <i alt="show" class="fa fa-eye-slash eye" (click)="showPassword2 = !showPassword2" [class.hide]="showPassword2"></i>
                    <i alt="hide" class="fa fa-eye eye" (click)="showPassword2 = !showPassword2" [class.hide]="!showPassword2"></i>
                
                    <mat-error class="margin_tp"
                    *ngIf="changePassForm.controls['NewPswd'].touched && changePassForm.controls['NewPswd'].errors?.pattern">
                   Invalid
                  </mat-error>
                  <mat-error class="margin_tp"
                    *ngIf="changePassForm.controls['NewPswd'].touched && changePassForm.controls['NewPswd'].errors?.required">
                  Mandatory
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row col-sm-12">
              <div class="col-sm-12 prpl">
                <button type="button" *ngIf="changepassCreate" class="btn btn-primary btn-icon-text floatright mt-1 p-0 fr" (click)="submit()">
                  <span style="display: contents; align-items: center;" class=" p-0">
                    <img width="20vh" src="../../assets/img/save.gif" class="p-0" style="margin-right: 5px;">
                    Save
                  </span>
                </button>
                <button type="button" [mat-dialog-close]="true" class="btn btn-primary btn-icon-text floatright mr-3 mt-1 fr">
                  <span style="display: contents; align-items: center;" class="p-0">
                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;" class="p-0">
                    Back
                  </span>
                </button>
              </div>
            </div>  
          </div>
        </div>
      </div>
    </form>
  </div>